module.exports = __webpack_public_path__ + "static/media/email.3a5f320e.svg";